import { useLayoutEffect, useRef } from 'react';

/** 输入框随内容增高；超过 maxHeight 后内部滚动。 */
export function useAutoGrow(value: string, maxHeight = 160) {
  const ref = useRef<HTMLTextAreaElement | null>(null);
  useLayoutEffect(() => {
    const el = ref.current;
    if (!el) return;
    el.style.height = 'auto';
    const next = Math.min(el.scrollHeight, maxHeight);
    el.style.height = `${Math.max(42, next)}px`;
    el.style.overflowY = el.scrollHeight > maxHeight ? 'auto' : 'hidden';
  }, [value, maxHeight]);
  return ref;
}
